import React, { useEffect, useState } from 'react';
import IPageProps from '../../interfaces/page';
import { handleLink } from '../../modules/utils';
import FooterPage from '../footer';

interface ISSOProfile {
    uuid: string;
    firstName: string;
    lastName: string;
    language: string;
    mail: string;
    isTeacher?: boolean;
    isStudent?: boolean;
}

const ChooseRolePage: React.FunctionComponent<IPageProps> = (props) => {
    const [ssoProfile, setSsoProfile] = useState<ISSOProfile>({
        uuid: '',
        firstName: '',
        lastName: '',
        language: '',
        mail: '',
        isTeacher: false,
        isStudent: false,
    });

    // 首次載入時，檢查是否有新北親師生或Google登入資料
    useEffect(() => {
        const iSchoolInfo = sessionStorage.getItem('iSchoolInfo');
        const googleInfo = sessionStorage.getItem('GoogleInfo');
        if (iSchoolInfo === null && googleInfo === null) {
            handleLink('/');
        } else {
            setSsoProfile(JSON.parse(iSchoolInfo ?? googleInfo!));
        }
    }, []);

    return (
        <>
            {(ssoProfile !== null) ?
                <>
                    <div style={{ backgroundColor: '#FCF9F3' }}>
                        <nav className="navbar navbar-expand-lg py-3" style={{ backgroundColor: '#FCF9F3' }}>
                            <div className="container align-items-center">
                                <div className="navbar-translate">
                                    <a className="navbar-brand logo" href="/" rel="tooltip" title="數位讀寫網" data-placement="bottom">
                                        數位讀寫網
                                    </a>
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div className="py-5">
                        <div className="container" style={{ maxWidth: '870px' }}>
                            <div className="row" style={{ borderRadius: '8px', boxShadow: '0px 0px 10px 5px #d7d7d7' }}>
                                <div className="col-12 col-md-6 order-2 order-md-1 bg-primary logreg px-4">
                                    <h4 className="py-3 text-center text-white fw-bolder">註冊說明</h4>
                                    <div className="text-white">
                                        <div className="text-start my-4">
                                            <div className="ms-3 mb-2" style={{ textIndent: '-1em' }}>1. 系統偵測到您同時具備教師與學生身分，請選擇要以哪種身分完成註冊。</div>
                                            <div className="ms-3 mb-2" style={{ textIndent: '-1em' }}>2. 註冊完成後，您的帳號將自動與新註冊的帳號綁定。</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 order-1 order-md-2 font-weight-bold bg-white login px-4">
                                    <h4 className="py-3 text-center text-primary fw-bolder">選擇註冊身分</h4>
                                    <hr className="hr1 my-1" />
                                    <div className="tab-content mt-4">
                                        <div className="text-center">
                                            姓名: {ssoProfile.lastName} {ssoProfile.firstName}
                                        </div>
                                        <div className="text-center"> Email:{ssoProfile.mail}</div>
                                        <div className="text-center mt-4">
                                            <button className="btn btn-round btn-primary my-2 text-nowrap" style={{ marginRight: '20px' }} onClick={() => handleLink('/newteacher')}>
                                                以教師身分註冊
                                            </button>
                                            <button className="btn btn-round btn-primary my-2 text-nowrap" onClick={() => handleLink('/newstudent')}>
                                                以學生身分註冊
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <FooterPage />
                </>
                : null}
        </>
    );
};

export default ChooseRolePage;
